/**
 * @file CustomNavTabs.tsx
 * @module app/custom/nav-tab/CustomNavTabs
 * @description Renders and exports the CustomNavTabs reusable navigation-tab component for switching related content panes.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import React from "react";
import { Nav } from "react-bootstrap";

interface Tab {
    label: string;
    value: string | number;
    count?: number;
}

interface NavTabsProps {
    tabs: Tab[];
    activeTab: number | string;
    onChange: (value: number | string) => void;
    classes?: string;
}

const CustomNavTabs: React.FC<NavTabsProps> = ({
    tabs,
    activeTab,
    onChange,
    classes = "",
}) => {
    return (
        <div className={`bg-light border border-r8px p-2 px-md-6 ${classes}`}>
            <Nav variant="pills">
                {tabs.map((tab) => (
                    <Nav.Item key={tab.value}>
                        <Nav.Link
                            eventKey={tab.value}
                            active={activeTab === tab.value}
                            onClick={() => onChange(tab.value)}
                            className="fs-16"
                        >
                            {tab.label}
                            {activeTab === tab.value && tab.count && tab.count > 0
                                ? ` (${tab.count})`
                                : ""}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>
        </div>
    );
};

export default CustomNavTabs;
